/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuditEventListResponse,
  ExportAuditEventsApiAuditEventsExportGetParams,
  HTTPValidationError,
  ListAuditEventsApiAuditEventsGetParams,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listAuditEventsApiAuditEventsGetResponse200 = {
  data: AuditEventListResponse;
  status: 200;
};

export type listAuditEventsApiAuditEventsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listAuditEventsApiAuditEventsGetResponseSuccess =
  listAuditEventsApiAuditEventsGetResponse200 & {
    headers: Headers;
  };
export type listAuditEventsApiAuditEventsGetResponseError =
  listAuditEventsApiAuditEventsGetResponse422 & {
    headers: Headers;
  };

export type listAuditEventsApiAuditEventsGetResponse =
  | listAuditEventsApiAuditEventsGetResponseSuccess
  | listAuditEventsApiAuditEventsGetResponseError;

export const getListAuditEventsApiAuditEventsGetUrl = (
  params?: ListAuditEventsApiAuditEventsGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/audit-events?${stringifiedParams}`
    : `/api/audit-events`;
};

/**
 * One page of the team's audit log, newest first, under the filters,
 * with how many rows match them in all (`total`, up to TOTAL_CAP).
 * Staff who are not the owner leave an `audit_log.view` row, folded to
 * one per ten minutes; the owner leaves none.
 * @summary List Audit Events
 */
export const listAuditEventsApiAuditEventsGet = async (
  params?: ListAuditEventsApiAuditEventsGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listAuditEventsApiAuditEventsGetResponse> => {
  return orvalFetch<listAuditEventsApiAuditEventsGetResponse>(
    getListAuditEventsApiAuditEventsGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAuditEventsApiAuditEventsGetQueryKey = (
  params?: ListAuditEventsApiAuditEventsGetParams,
) => {
  return [`/api/audit-events`, ...(params ? [params] : [])] as const;
};

export const getListAuditEventsApiAuditEventsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListAuditEventsApiAuditEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAuditEventsApiAuditEventsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>
  > = ({ signal }) =>
    listAuditEventsApiAuditEventsGet(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAuditEventsApiAuditEventsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>
>;
export type ListAuditEventsApiAuditEventsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListAuditEventsApiAuditEventsGet<
  TData = Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | ListAuditEventsApiAuditEventsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
          TError,
          Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAuditEventsApiAuditEventsGet<
  TData = Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListAuditEventsApiAuditEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
          TError,
          Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAuditEventsApiAuditEventsGet<
  TData = Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListAuditEventsApiAuditEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Audit Events
 */

export function useListAuditEventsApiAuditEventsGet<
  TData = Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListAuditEventsApiAuditEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAuditEventsApiAuditEventsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAuditEventsApiAuditEventsGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type exportAuditEventsApiAuditEventsExportGetResponse200 = {
  data: unknown;
  status: 200;
};

export type exportAuditEventsApiAuditEventsExportGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type exportAuditEventsApiAuditEventsExportGetResponseSuccess =
  exportAuditEventsApiAuditEventsExportGetResponse200 & {
    headers: Headers;
  };
export type exportAuditEventsApiAuditEventsExportGetResponseError =
  exportAuditEventsApiAuditEventsExportGetResponse422 & {
    headers: Headers;
  };

export type exportAuditEventsApiAuditEventsExportGetResponse =
  | exportAuditEventsApiAuditEventsExportGetResponseSuccess
  | exportAuditEventsApiAuditEventsExportGetResponseError;

export const getExportAuditEventsApiAuditEventsExportGetUrl = (
  params?: ExportAuditEventsApiAuditEventsExportGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/audit-events/export?${stringifiedParams}`
    : `/api/audit-events/export`;
};

/**
 * The team's audit log under the filters as a CSV download, newest
 * first, at most EXPORT_MAX_ROWS rows (`X-Export-Max-Rows`), and
 * `X-Export-Truncated` says when more matched. The upper bound is the
 * moment the export started, so the rows written while it streams (its
 * own `audit_log.export` row among them) wait for the next one.
 * @summary Export Audit Events
 */
export const exportAuditEventsApiAuditEventsExportGet = async (
  params?: ExportAuditEventsApiAuditEventsExportGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<exportAuditEventsApiAuditEventsExportGetResponse> => {
  return orvalFetch<exportAuditEventsApiAuditEventsExportGetResponse>(
    getExportAuditEventsApiAuditEventsExportGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getExportAuditEventsApiAuditEventsExportGetQueryKey = (
  params?: ExportAuditEventsApiAuditEventsExportGetParams,
) => {
  return [`/api/audit-events/export`, ...(params ? [params] : [])] as const;
};

export const getExportAuditEventsApiAuditEventsExportGetQueryOptions = <
  TData = Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ExportAuditEventsApiAuditEventsExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExportAuditEventsApiAuditEventsExportGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>
  > = ({ signal }) =>
    exportAuditEventsApiAuditEventsExportGet(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportAuditEventsApiAuditEventsExportGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>
>;
export type ExportAuditEventsApiAuditEventsExportGetQueryError =
  ErrorType<HTTPValidationError>;

export function useExportAuditEventsApiAuditEventsExportGet<
  TData = Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | ExportAuditEventsApiAuditEventsExportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
          TError,
          Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportAuditEventsApiAuditEventsExportGet<
  TData = Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ExportAuditEventsApiAuditEventsExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
          TError,
          Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportAuditEventsApiAuditEventsExportGet<
  TData = Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ExportAuditEventsApiAuditEventsExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Audit Events
 */

export function useExportAuditEventsApiAuditEventsExportGet<
  TData = Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ExportAuditEventsApiAuditEventsExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAuditEventsApiAuditEventsExportGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportAuditEventsApiAuditEventsExportGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
